/* @flow strict */

import * as React from 'react';
import Switcher from '/client/src/components/switcher';
import SimpleSelect from '/client/src/components/forms/select';

type PropsType = {
    isEvent?: boolean,
    isLoading: boolean,
    globalsync: boolean,
    listid: string,
    sync: boolean,
    lists: [],
    onHandleSettingsChange: ({ }) => void
};


const MailchimpSettings = ({
    isEvent,
    isLoading,
    globalsync,
    listid,
    sync,
    lists,
    onHandleSettingsChange
}: PropsType): React.Element<'div'> => {
    const [isGlobalSync, setGlobalSync] = React.useState(globalsync);
    const [listId, setListId] = React.useState(listid);
    const [isSync, setSync] = React.useState(sync);

    React.useEffect(() => {
        setGlobalSync(globalsync);
        setListId(listid);
        setSync(sync);
    }, [globalsync, listid, sync]);

    const convertedList = lists && lists.map((el: {}): {} => ({
        label: el.name,
        value: el.id
    }));

    return (
        <div className='mailchimp-sync'>
            {isLoading && <div className='csspinner' />}
            {
                isEvent ?
                    <h5>Add attendees from this event to MailChimp lists to use MailChimp to email attendees.</h5>
                    :
                    <h5>Add all attendes to a mailchimp list</h5>
            }
            <div className='mailchimp-sync_container'>
                <div className='mailchimp-sync_item mailchimp-sync-toggler'>
                    <span className='key'>Enable Mailchimp</span>
                    <span className='value'>
                        <Switcher
                          className='form-switcher pull-left'
                          checked={isGlobalSync}
                          id={1}
                          index={1}
                          onCallback={() => {
                                setGlobalSync(!isGlobalSync);
                                onHandleSettingsChange(
                                    !isGlobalSync,
                                    listId,
                                    isSync
                                );
                            }}
                        />
                    </span>
                </div>
                <div className='mailchimp-sync_item'>
                    <SimpleSelect
                      value={listId}
                      label='Mailchimp List'
                      callBack={(e: any) => {
                            setListId(e.target.value);
                            onHandleSettingsChange(
                                isGlobalSync,
                                e.target.value,
                                isSync
                            );
                        }
                        }
                      items={convertedList}
                    />
                </div>
                <div className='mailchimp-sync_item' >
                    <div className='mailchimp-sync_radio'>

                        <input type="radio" id='mcs1' checked={isSync} onChange={() => {
                            setSync(true);
                            onHandleSettingsChange(
                                isGlobalSync,
                                listId,
                                true
                            );
                        }}
                        />
                        <label htmlFor='mcs1'>
                            Synchronize - Add all attendees to list and remove from list if ticket voided.
                        </label>
                    </div>
                    <div className='mailchimp-sync_radio'>
                        <input type="radio" id='mcs2' checked={!isSync} onChange={() => {
                            setSync(false);
                            onHandleSettingsChange(
                                isGlobalSync,
                                listId,
                                false
                            );
                        }}
                        />
                        <label htmlFor='mcs2'>
                            Don't Synchronize - Add all attendees to list and do not remove from list if ticket voided.
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MailchimpSettings;
